<template>
	<div class="ask-stock">
		<div class="container">
			<!-- Header -->
			<div class="page-header flex-center">
				<h1 class="page-title">Tanyakan Stock</h1>
			</div>
			<div class="page-content">
				<!-- Table Menu -->
				<div class="table-list-menu">
					<div class="row">
						<div class="col-sm-6 pt-2">
							<!-- Search Keyword -->
							<input
								type="text"
								class="input
								form-control form-control-sm users-search-box w-50 d-inline mr-2"
								placeholder="Seller / Supplier / Product Name ..."
								autocomplete="off"
								@input="onKeywordChange"
								v-model="keyword"
							/>
								<button type="button" class="btn btn-light btn-sm flex-center mr-2 d-inline" @click="isShowFilter = true">
									<i class="material-icons mr-1">filter_list</i>Filter
								</button>

								<!-- Clear Filter -->
								<button type="button" class="btn btn-plain btn-sm" @click="clearFilter" v-if="isFilterOn">
									{{ $t('Clear Filter') }}
								</button>
						</div>
						<div class="col-sm-6">
							<div class="table-filters d-flex align-items-center justify-content-end ml-a">
								<div class="page-header-right text-right ml-a">
									<!-- Date Filter -->
									<daterangepicker
										:presets="filterDatePresets"
										:start="since"
										:end="until"
										@selected="setFilterDate"
										ref="datePicker"
									>
									</daterangepicker>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Ticket List -->
				<div class="users-list table-responsive">
					<table class="users-list-table table table-primary table-striped">
						<thead>
							<tr class="text-center">
								<th width="3%">
									No
								</th>
								<th width="15%" class="th-sort text-left" :class="sortClass('seller_name')"
									@click="changeSorting('seller_name')" >
									Seller Name
								</th>
								<th width="15%" class="th-sort text-left" :class="sortClass('supplier_name')"
									@click="changeSorting('supplier_name')">
									Supplier Name
								</th>
								<th width="15%" class="th-sort text-left" :class="sortClass('product_name')"
									@click="changeSorting('product_name')">
									Product Name
								</th>
								<th width="5%" class="text-center">
									Chat
								</th>
								<th width="12%" class="th-sort text-left" :class="sortClass('updated_at')"
									@click="changeSorting('updated_at')">
									Updated at
								</th>
								<th width="10%" class="th-sort text-center" :class="sortClass('status')"
									@click="changeSorting('status')" >
									Status
								</th>
								<th width="10%" class="text-left">
									Action
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in items" :key="'list-'+ index" @click="openNoteModal(item, $event)" class="text-left">
								<td class="text-center">
									{{ index+1 }}
								</td>
								<td class="">
									<span @click="openUserProfile(item)" class="text-primary" role="button">
										{{ handleEmpty(item.seller_name) }}
									</span>
								</td>
								<td>
									{{ handleEmpty(item.supplier_name) }}
								</td>
								<td>
									<a :href="'/admin/products?product_id=' + item.product_id" target="_blank">
										{{ item.product_name }}
									</a>
								</td>
								<td class="text-center">
									<span @click="followUp(item)" role="button">
										<i class="bi bi-whatsapp text-success"></i>
									</span>
								</td>
								<td>
									{{ formatDate(moment, item.updated_at, 'DD-MM-YYYY HH:mm:ss') }}
								</td>
								<td>
									<span :class="item.status" class="btn btn-sm w-100">
										{{ getStatus(item.status) }}
									</span>
								</td>
								<td>
									<div class="btn-group">
										<button :class="{'is-loading' : isUpdating && selectedAskStock._id === item._id}" class="btn btn-default btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
											{{ $t('Change Status') }}
										</button>
										<div class="dropdown-menu">
											<button
												class="dropdown-item"
												@click="changeStatus('new', item._id, item.status)"
												:disabled="item.status === 'new'"
											>
												New
											</button>
											<button
												class="dropdown-item"
												@click="changeStatus('pending', item._id, item.status)"
												:disabled="item.status === 'pending'"
											>
												Pending
											</button>
											<button
												class="dropdown-item"
												@click="changeStatus('in_progress', item._id, item.status)"
												:disabled="item.status === 'in_progress'"
											>
												In Progress
											</button>
											<button
												class="dropdown-item"
												@click="changeStatus('resolved', item._id, item.status)"
												:disabled="item.status === 'resolved'"
											>
												Resolved
											</button>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
					<div class="table-fetch-status" v-if="isFetching">
						<div class="is-loading large dark m-auto"></div>
					</div>
					<!-- Empty -->
					<div class="list-empty" v-if="items.length === 0 && isFetching === false">
						<i class="material-icons mr-2">error_outline</i>
						<span v-if="keyword === ''">There is no Ask Stock yet.</span>
						<span v-else>No Ask Stock was found</span>
					</div>
				</div>
			</div>
		</div>
		<!-- Modals -->
		<div class="modals">
			<!-- Table Filter -->
			<modal class="table-filter-modal" size="medium" @close="isShowFilter = false" v-if="isShowFilter">
				<div slot="header">
					<h3><i class="material-icons">filter_list</i>Filter chat</h3>
				</div>
				<div slot="body">
					<!-- deleted -->
					<div class="form-group">
						<label for="">
							<b class="">
								Status
							</b>
						</label>
						<select class="form-control" v-model="selectedStatus">
							<option value="all">All</option>
							<option value="new">New</option>
							<option value="pending">Pending</option>
							<option value="in_progress">In Progress</option>
							<option value="resolved">Resolved</option>
						</select>
					</div>
				</div>
				<div slot="footer">
					<button type="button" class="btn btn-light" @click="isShowFilter = false">{{ $t('Close') }}</button>
					<button type="button" class="btn btn-primary" :class="{'is-loading': isFetching}" @click="applyFilter">Apply</button>
				</div>
			</modal>
		</div>
		<div class="modals">
			<modal
				class="table-filter-modal"
				size="large"
				@close="isOpenNoteModal = false"
				v-if="isOpenNoteModal">
				<div slot="header">
					<h3>Detail Ask Stock</h3>
				</div>
				<div slot="body">
					<ticket-loading :is-fetching="isFetchingDetail" v-if="isFetchingDetail"/>
					<div class="ticket" v-else>
						<div class="ticket-info">
							<div class="info-row">
								<span class="text-bold">{{ $t('Supplier Name') }}:</span>
								<span class="ml-1">{{handleEmpty(selectedAskStock.supplier_name)}}</span>
							</div>
							<div class="info-row">
								<span class="text-bold">{{ $t('Seller Name') }}:</span>
								<span class="ml-1">{{ handleEmpty(selectedAskStock.seller_name) }}</span>
							</div>
							<div class="info-row">
								<span class="text-bold">{{ $t('Product Name') }}:</span>
								<span class="ml-1">{{ handleEmpty(selectedAskStock.product_name) }}</span>
							</div>
							<div class="info-row">
								<span class="text-bold">{{ $t('Status') }}:</span>
								<span class="ml-1">{{ getStatus(selectedAskStock.status) }}</span>
							</div>
						</div>
						<ticket-message :list-message="listMessage" :user-data="user"/>
						<div class="form-group mb-1 mt-4">
							<label class="text-bold">
								Tulis catatan
							</label>
							<textarea
								:class="{'is-invalid' : errorForm.message}"
								class="form-control"
								rows="2"
								placeholder="Tulis pesan anda di sini"
								v-model="content">
							</textarea>
							<div class="invalid-feedback" v-if="errorForm.message">
								{{ errorForm.message }}
							</div>
						</div>
					</div>
				</div>

				<div slot="footer">
					<button type="button" class="btn btn-light" @click="isOpenNoteModal = false">{{ $t('Close') }}</button>
					<button type="button" :class="{'is-loading' : isUpdating }" class="btn btn-primary" @click="saveMessage">Send</button>
				</div>
			</modal>
		</div>
		<!-- Modal Seller Profile -->
		<modal-seller-profile
			:user="selectedAskStock.sellers"
			@close="closeSellerProfile"
			@verification="false"
			:source="'ask-stock'"
			v-if="isModalSellerProfileVisible"
		/>
		<!-- Follow Up -->
		<follow-up-modal :name="followUpName" :number="followUpNumber" :message="followUpMessage"
		@close="hideFollowUp" v-if="isFollowUpVisible" />
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import Daterangepicker from '@/components/Daterangepicker.vue';
import Modal from '@/components/Modal.vue';
import TicketLoading from '@/components/admin/ticket/TicketLoading.vue';
import TicketMessage from '@/components/admin/ticket/TicketMessage.vue';
import ModalSellerProfile from '@/components/ModalSellerProfile.vue';
import FollowUpModal from '@/components/FollowUpModal.vue';
import {
	duplicateVar,
	getDateRange,
	formatDate,
	toTitleCase,
	validatePhoneNumber,
	formatWaNumber,
	getDateNow,
} from '@/lib/helper';
import adminApi from '@/api/admin';

export default {
	name: 'AdminAskStock',
	components: {
		Daterangepicker,
		Modal,
		TicketMessage,
		TicketLoading,
		FollowUpModal,
		ModalSellerProfile,
	},
	data() {
		return {
			keyword: '',
			since: '',
			until: '',
			limit: 25,
			sort_by: null,
			sort: 'desc',
			isFetching: false,
			isFetchingDetail: false,
			items: [],
			isShowDetail: false,
			isUpdateStatusModal: false,
			selectedStatus: 'all',
			listMessage: [],
			isUpdating: false,
			isOpenNoteModal: false,
			content: '',
			isShowFilter: false,
			isFollowUpVisible: false,
			followUpName: '',
			followUpNumber: '',
			followUpMessage: '',
			selectedAskStock: {},
			errorForm: {
				message: null,
			},
			isModalSellerProfileVisible: false,
		};
	},
	methods: {
		...mapActions({
			decreaseAskStock: 'sidebar/decreaseAskStock',
			increaseAskStock: 'sidebar/increaseAskStock',
		}),
		getDateNow,
		changeStatus(status, id, currentStatus) {
			this.selectedAskStock._id = id;
			this.isUpdating = true;
			const updatedAt = this.getDateNow();
			const params = {
				status,
				id,
			};

			const callback = () => {
				this.isUpdating = false;
				const update = this.items.find(askStock => askStock._id === id);
				update.status = status;
				update.updated_at = updatedAt;

				this.$notify({
					group: 'app',
					title: 'Ask Stock',
					text: `Succesfully updated to ${status}`,
					type: 'success',
				});

				if (currentStatus === 'new') {
					this.decreaseAskStock(1);
				}

				if (update.status === 'new') {
					this.increaseAskStock(1);
				}
			};

			const errorCallback = () => {
				this.isUpdating = false;
				this.resetFilter();
				this.$notify({
					group: 'app',
					title: 'Ask Stock',
					text: 'Failed to update status',
					type: 'error',
				});
			};

			adminApi.updateStatusAskStock(params, callback, errorCallback);
		},
		handleEmpty(variable) {
			return variable ?? '-';
		},
		saveMessage() {
			this.validateMessage();

			const isErrorExist = Object.values(this.errorForm).find(val => val !== '');

			if (isErrorExist) {
				return;
			}

			this.isUpdating = true;
			const params = {
				ask_stock: this.selectedAskStock,
				content: this.content,
			};

			const callback = (response) => {
				this.isUpdating = false;
				this.content = '';
				this.listMessage.push(response.data);
			};

			const errorCallback = (response) => {
				this.isUpdating = false;
				this.$notify({
					group: 'app',
					title: 'Ask Stock',
					text: response.message,
					type: 'error',
				});
			};

			adminApi.saveMessageAskStock(params, callback, errorCallback);
		},
		getStatus(status) {
			return toTitleCase(status.replace('_', ' '));
		},
		openStatusModal(ticket) {
			this.selectedAskStock = duplicateVar(ticket);
			this.isUpdateStatusModal = true;
		},
		openNoteModal(askStock, event) {
			if (event.target.tagName.toLowerCase() === 'button' || event.target.tagName.toLowerCase() === 'a' || event.target.tagName.toLowerCase() === 'i' || event.target.tagName.toLowerCase() === 'span') {
				return;
			}
			this.isFetchingDetail = true;
			this.selectedAskStock = duplicateVar(askStock);
			this.isOpenNoteModal = true;

			const params = {
				id: this.selectedAskStock._id,
			};

			const callback = (response) => {
				this.isFetchingDetail = false;
				this.listMessage = response.data;
			};

			const errorCallback = () => {
				this.isFetchingDetail = false;
				this.resetFilter();
				this.$notify({
					group: 'app',
					title: 'Ask Stock',
					text: 'Failed to update status ticket',
					type: 'error',
				});
			};
			adminApi.listAskStockMessage(params, callback, errorCallback);
		},
		toTitleCase,
		resetItems() {
			this.items = [];
			this.page = 1;
		},
		formatDate,
		getFetchParams() {
			const params = {
				limit: this.limit,
				page: this.page,
				since: this.since,
				until: this.until,
			};

			if (this.sort_by) {
				params.sort_by = this.sort_by;
				params.sort = this.sort;
			}

			if (this.keyword !== '') {
				params.keyword = this.keyword;
			}

			if (this.selectedStatus) {
				params.status = this.selectedStatus;
			}

			return params;
		},
		fetchItems(reset = true) {
			this.isFetching = true;
			if (reset) {
				this.resetItems();
			}

			const params = this.getFetchParams();

			const callback = (response) => {
				this.isFetching = false;
				const items = response.data;
				this.isShowFilter = false;
				if (items.length > 0) {
					this.page++;
					this.items = this.items.concat(items);
				} else {
					this.isAll = true;
				}
			};

			const errorCallback = () => {
				this.isFetching = false;
				this.isShowFilter = false;
			};

			adminApi.listAskStock(params, callback, errorCallback);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchItems(false);
				}
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetchItems(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		setFilterDate(filterDate) {
			this.filterDate = filterDate;
			const dateFormat = 'YYYY-MM-DD';
			const since = dayjs(filterDate.start).format(dateFormat);
			const until = dayjs(filterDate.end).format(dateFormat);
			this.since = since;
			this.until = until;
			const query = duplicateVar(this.$route.query);
			query.since = since;
			query.until = until;
			const params = { query };
			this.$router.push(params);
			this.fetchItems(true);
		},
		initFilterDate() {
			const dateRange = getDateRange();
			const hasSinceQuery = this.sinceQuery && this.sinceQuery !== '';
			const hasUntilQuery = this.untilQuery && this.untilQuery !== '';
			const sinceDate = hasSinceQuery
				? dayjs(this.sinceQuery)
				: dayjs(dateRange.start);
			const untilDate = hasUntilQuery
				? dayjs(this.untilQuery)
				: dayjs(dateRange.end);
			const filterDate = {
				start: sinceDate,
				end: untilDate,
			};
			this.filterDate = filterDate;

			const dateFormat = 'YYYY-MM-DD';
			this.since = sinceDate.format(dateFormat);
			this.until = untilDate.format(dateFormat);
		},
		applyFilter() {
			this.fetchItems(true);
		},
		resetFilter() {
			this.selectedAskStock = {};
			this.keyword = '';
		},
		clearFilter() {
			this.resetFilter();
			this.applyFilter();
		},
		onKeywordChange() {
			this.ooDelay(() => {
				if (this.isAdmin) {
					this.fetchItems();
				} else if (this.isSupport) {
					if (this.keyword.trim() === '') {
						this.resetItems();
					} else {
						this.fetchItems();
					}
				}
			}, 1000);
		},
		initData() {
			this.initFilterDate();
			this.fetchItems(true);
		},
		validatePhoneNumber,
		followUp(item) {
			this.generateFollowUp(item);
			this.isFollowUpVisible = true;
		},
		generateFollowUp(item) {
			const phone = item.phone;
			const sellerName = item.seller_name || '';
			const followUpMessages = '';
			this.followUpNumber = formatWaNumber(phone);
			this.followUpName = sellerName;
			this.followUpMessage = followUpMessages;
		},
		hideFollowUp() {
			this.followUpNumber = '';
			this.followUpName = '';
			this.followUpMessage = '';
			this.isFollowUpVisible = false;
		},
		validateMessage() {
			this.errorForm.message = '';
			if (this.content.trim() === '') {
				this.errorForm.message = 'Message wajib diisi';
			}
		},
		openUserProfile(data) {
			this.selectedAskStock = data;
			this.isModalSellerProfileVisible = true;
		},
		closeSellerProfile() {
			this.selectedItem = null;
			this.isModalSellerProfileVisible = false;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			filterDatePresets: 'filterDatePresets',
		}),
		sinceQuery() {
			const since = this.$route.query.since;
			return since;
		},
		untilQuery() {
			const until = this.$route.query.until;
			return until;
		},
		isFilterOn() {
			return this.keyword !== '';
		},
	},
	created() {
		this.initData();
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style lang="scss" scoped>

.new{
	color: white;
	border-color: #e74c3c;
    background-color: #e74c3c;
}

.resolved{
	color: white;
	border-color: #139a4b;
    background-color: #139a4b;
}

.pending{
	color: white;
	border-color: #F28900;
    background-color: #F28900;

}

.in_progress {
	color: white;
	border-color: #1288E5;
    background-color: #1288E5;
}

</style>
